module.exports = __webpack_public_path__ + "85da32a9b078d2d625635b05ca603ad7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Assets/skewers.png
// module id = 1346
// module chunks = 0